<input type="checkbox" id="switch" />
<label for="switch">Toggle</label>
